/** @format */

import {makeStyles, createStyles} from '@mui/styles';
import {Theme} from '@mui/material/styles';

export const useSensorBarListStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      color: theme.palette.figma_gray_middle_dark?.main,
      fontSize: 12,
      fontWeight: 500,
      lineHeight: '16px',
      letterSpacing: '0.001px',
    },
    description: {
      color: '#F1F1F1',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '26px',
      letterSpacing: '0.17px',
    },
    rightContainer: {
      minWidth: theme.spacing(26),
    },
    recommendationsWrapper: {
      width: '100%',
      maxWidth: '160px',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
        marginTop: theme.spacing(4),
      },
    },
    recommendationsText: {
      color: theme.palette.figma_gray_middle_dark?.main,
      fontSize: 14,
      fontWeight: 400,
    },
    recommendationsContainer: {
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(1.5, 4),
      borderRadius: theme.spacing(2),
      border: '1px solid #8B8B8B',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
      },
    },
    yellowText: {
      color: '#AA8258',
    },
    redText: {
      color: '#AE5658',
    },
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: theme.spacing(2),
      padding: theme.spacing(4),
      gap: theme.spacing(2),
      borderRadius: theme.spacing(2),
      background: '#202020',
      boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
      borderRight: `2px solid ${theme.palette.figma_gray_middle_dark?.main}`,
      borderLeft: `2px solid ${theme.palette.figma_gray_middle_dark?.main}`,
      cursor: 'pointer',
      userSelect: 'none',
      '&:first-of-type': {
        marginTop: 0,
      },
      '& .MuiButtonBase-root': {
        padding: 0,
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 0,
        backgroundColor: 'transparent',
        [theme.breakpoints.down('sm')]: {
          flexWrap: 'wrap',
        },
      },
    },
    yellowBorder: {
      borderColor: '#AA8258',
    },
    redBorder: {
      borderColor: '#AE5658',
    },
    rowIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 66,
      height: 66,
      marginRight: theme.spacing(4),
      borderRadius: theme.spacing(2),
      background: '#2B2B2B',
    },
    textContainer: {
      maxWidth: '82%',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
      },
    },
    content: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    compactIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 16,
      height: 16,
    },
  }),
);
